var LogLevel;
(function(LogLevel2) {
  LogLevel2["INFO"] = "info";
  LogLevel2["WARN"] = "warn";
  LogLevel2["ERROR"] = "error";
})(LogLevel || (LogLevel = {}));
export {
  LogLevel
};

//# sourceMappingURL=types.js.map